import React from "react";
import { ChevronRightIcon } from "lucide-react";
import { useBreadcrumb } from "../../lib/hooks/breadcrumb-hooks";

const Breadcrumb: React.FC = () => {
	const { breadcrumbs } = useBreadcrumb();

	return (
		<nav aria-label="Breadcrumb">
			<ol className="list-none p-0 inline-flex">
				{breadcrumbs.map((item, index) => (
					<li
						key={index}
						className={`flex items-center ${
							index !== breadcrumbs.length - 1 ? "mr-2" : ""
						}`}
					>
						<a
							href={item.href}
							className={`transition-colors text-sm duration-200 ease-in-out ${
								index === breadcrumbs.length - 1
									? "text-gray-900 font-bold"
									: "text-gray-400 hover:text-gray-900"
							}`}
						>
							{item.label}
						</a>
						{index !== breadcrumbs.length - 1 && (
							<ChevronRightIcon
								className={`w-5 h-5 mx-10 ${
									index === breadcrumbs.length - 2
										? "text-gray-900"
										: "text-gray-400"
								}`}
								aria-hidden="true"
							/>
						)}
					</li>
				))}
			</ol>
		</nav>
	);
};

export { Breadcrumb };
